import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from 'react-error-boundary';
import {Provider} from 'react-redux';
import {STORE_CONTEXT} from '../constants/redux';
import '../assets/styles/app.scss';
import {historyAttributesType, storeAttributesType} from '../constants/proptype-validation';
import cx from 'classnames';
import {viewTypes} from '../constants/view-types';
import MatrixProvider from '@adsk/bim360-matrix-react-matrix-provider';
import {ENV_TYPE_BY_ISSUES_ENV_TYPE} from '../constants/envs';
import {getToken} from '../utils/getToken';
import AppLoading from './AppLoading';
import DeletedUsersProvider from './deleted-users/DeletedUsersProvider';

const ReduxProvider = ({DevTools, store, history, viewType, locale, onError, env, region, currentProject}) => {
  const fixModalOffset = navigator.userAgent.indexOf('Edge') >= 0 && viewType === viewTypes.DOCUMENT;
  const rootElementClassName = cx('isui-root-element', `isui-root--${viewType}`, {
    'isui-root-element--modal-offset-fix': fixModalOffset
  });

  const containerComponent = (
    <Provider store={store} context={STORE_CONTEXT}>
      <div className={rootElementClassName}>
        <MatrixProvider
          locale={locale}
          env={ENV_TYPE_BY_ISSUES_ENV_TYPE[env]}
          region={region}
          project={currentProject}
          getToken={() => getToken(store)}
        >
          <DeletedUsersProvider projectId={currentProject.id}>
            <AppLoading store={store} history={history} preventLoader={viewType === viewTypes.ISSUE_DETAILS_MODAL} />
          </DeletedUsersProvider>
        </MatrixProvider>
        {DevTools ? <DevTools store={store} /> : null}
      </div>
    </Provider>
  );

  if (onError) {
    return <ErrorBoundary onError={onError}>{containerComponent}</ErrorBoundary>;
  } else {
    return containerComponent;
  }
};

ReduxProvider.propTypes = {
  store: storeAttributesType.isRequired,
  history: historyAttributesType.isRequired,
  DevTools: PropTypes.func,
  onError: PropTypes.func,
  viewType: PropTypes.string,
  locale: PropTypes.string.isRequired,
  env: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired
};

ReduxProvider.displayName = 'ReduxProvider';

export default ReduxProvider;
